import _find from 'lodash/find';
import _remove from 'lodash/remove';
import _debounce from 'lodash/debounce';
import set from 'lodash/set';
import get from 'lodash/get';
import viewGroupRegisterTemplate from './../group-register/view-group-register/view-group-register.html';
import changeGroupTemplate from './change-group/change-group.html';
import addStudentsTemplate from './../../settings/add-students/add-students.html';
import studentInfoTemplate from './../../dashboard/student-info/student-info.html';
import manageStudentDialogTemplate from '../../../components/manage-student/manage-student-dialog.html';
import './student-list.scss';
import template from './student-list.html';

class StudentListComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SchedulePointService,
    StudentService,
    GroupService,
    SchoolClassService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchedulePointService = SchedulePointService;
    this.StudentService = StudentService;
    this.GroupService = GroupService;
    this.SchoolClassService = SchoolClassService;

    this.dataTable = {};
    this.schedulePoints = [];
    this.columnKeys = ['fullName', 'groupName', 'schoolClassName'];
    this.loadPageCallbackWithDebounce = {};
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER' || this.me.roleName === 'HEAD_TEACHER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.students) {
      this.students = Object.assign([], this.students);
    }

    if (changes.groups) {
      this.groups = Object.assign([], this.groups);
    }

    if (changes.schoolClasses) {
      this.schoolClasses = Object.assign([], this.schoolClasses);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page = 1, pageSize = 0) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    return this.StudentService.getAll({
      offset,
      limit: pageSize
    }).then(result => {
      this.students = result.data.students;
      return {
        results: result.data.students,
        totalResultCount: result.data.total
      };
    });
  }

  showInfo(id, ev) {
    ev.stopPropagation();
    this.StudentService.getInfo(id)
      .then(student => {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'StudentInfoController',
          locals: {student},
          template: studentInfoTemplate,
          disableParentScroll: true,
          clickOutsideToClose: true,
          targetEvent: ev
        });
      });
  }

  showRegister(id, ev) {
    this.StudentService.getGroupsRegisterRecords(id)
      .then(result => {
        result.forEach((item, idx) => {
          item.primary = idx === 0;
        });
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'ViewGroupRegisterController',
          template: viewGroupRegisterTemplate,
          locals: {
            groupRegisterRecords: result,
            studentId: id,
            groups: this.groups
          },
          clickOutsideToClose: true,
          targetEvent: ev
        }).then(() => this.loadPageCallbackWithDebounce(this.dataTable.mdtPaginationHelper.page));
      });
  }

  changeGroup(id, ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ChangeGroupController',
      template: changeGroupTemplate,
      locals: {
        groups: this.groups,
        studentId: id
      },
      clickOutsideToClose: true,
      targetEvent: ev
    }).then(() => this.loadPageCallbackWithDebounce(this.dataTable.mdtPaginationHelper.page));
  }

  remove(studentId) {
    const student = this.getStudent(studentId);
    this.GroupService.deleteFromGroup(student.groupId, [Number(studentId)])
      .then(() => {
        _remove(this.students, student => student.id === studentId);
        this.loadPageCallbackWithDebounce(this.dataTable.mdtPaginationHelper.page);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Usunięto ucznia ze świetlicy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  assignStudents(ev) {
    if (this.groups.length === 0) {
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak grup świetlicowych')
          .textContent('Przed dodaniem uczniów do grupy, dodaj przynajmniej jedną grupę.')
          .ariaLabel('Przed dodaniem uczniów do grupy, dodaj przynajmniej jedną grupę.')
          .ok('Zamknij')
          .targetEvent(ev)
      );
      return false;
    }

    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddStudentsController',
      locals: {schoolClasses: this.schoolClasses, groups: this.groups},
      template: addStudentsTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    }).then(() => {
      this.loadPageCallbackWithDebounce(this.dataTable.mdtPaginationHelper.page);
    });
  }

  getStudent(id) {
    return _find(this.students, student => student.id === id);
  }

  manageStudent(studentId, event) {
    event.stopPropagation();
    const student = this.getStudent(studentId);
    this.$mdDialog.show({
      bindToController: true,
      controller: 'ManageStudentDialogController',
      controllerAs: 'ctrl',
      template: manageStudentDialogTemplate,
      disableParentScroll: true,
      targetEvent: event,
      locals: {
        student,
        successCallback: ({result}) => {
          set(student, 'isPermittedToLeaveOnOwn', result.isPermittedToLeaveOnOwn);
          set(student, 'permissionsSchedule', result.permissionsSchedule);
        },
        errorCallback: () => {}
      }
    });
  }

  affiliateToDefaultGroup(studentId) {
    const student = this.getStudent(studentId);
    return get(student, 'isGroupDefault', false);
  }
}

export const StudentList = {
  bindings: {
    me: '<',
    students: '<',
    groups: '<',
    schoolClasses: '<'
  },
  template,
  controller: StudentListComponent
};
